<template>
    <div class="components-container" style="margin:0; padding: 0 10px;">
        <el-form class="small-space" :model="auditForm" ref="auditForm" label-position="left" label-width="80px">
            <el-form-item label="审核意见" prop="jcCzxmc">
                <el-input type="textarea" :rows="4" v-model="auditForm.opinion" placeholder="请填写审核意见" maxlength="500" show-word-limit>
                </el-input>
            </el-form-item>
        </el-form>
        <div style="width:100%; text-align:center;">
            <el-button type="success" :loading="formSubmiting" @click="audit('1')">通 过</el-button>
            <el-button style="margin-left: 10px;" type="danger" :loading="formSubmiting" @click="audit('2')">驳 回</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg } from "utils/message";

    export default {
        props: ['itemCode','relatedCode','auditLevel'],
        data() {
            return {
                formSubmiting: false,
                auditForm: {
                    itemCode: '', //审核项编号
                    relatedCode: '', //相关编号（审核内容的主键）
                    auditLevel: '', //审核层级
                    auditState: '', //审核状态
                    opinion: '', //审核意见
                },
            };
        },
        mounted() {
            this.auditForm.itemCode = this.itemCode;
            this.auditForm.relatedCode = this.relatedCode;
            this.auditForm.auditLevel = this.auditLevel;
        },
        methods: {
            audit(type){
                if(type=='2' && this.auditForm.opinion == ""){
                    this.$message({
                        message: '审核驳回必须填写审核意见！',
                        type: 'warning'
                    });
                    return;
                }
                
                let msg = "";
                if(type=='1'){
                    msg = '是否确认审核通过？';
                }else{
                    msg = '是否确认审核驳回？';
                }
                
                this.$confirm(msg,'提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'el-message-box-mobile',
                    type: 'warning'
                }).then(() => {
                    this.formSubmiting = true;
                    this.auditForm.auditState = type;
                
                    this.$api.common.audit.audit({
                        data: this.auditForm,
                    }).then((response) => {
                        let state = response.data.data.state;
                
                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: "审核成功",
                                type: "success",
                                duration: 1500,
                            });
                
                            this.auditCallback();
                        }else{
                            this.$notify({
                                title: "失败",
                                message: "保存失败",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                
                    this.formSubmiting = false;
                });
            },
            auditCallback() {
                this.$emit("auditCallback", this.auditForm);
            },
        },
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// audit.vue?3eadc85e